// removed by extract-text-webpack-plugin
module.exports = {"component":"_1IkoY1oyvkcKKGsQaWvKHo","imgAndDescribe":"_26iSsRytm-rSkknw48yLug","backgroundImg":"_3-pihAtoYGLhwfOBrTT6qp","logo":"UIxsNujS-JdW_Hmf1xxYT","middleImgContainer":"_2WsTaqQBkFNcN_Ls4KeZUv","textBox":"RVF5hqfuELv6ynlw8IkfF","text":"_1Vp6mrjuFjkgEOr4iMM0VC","imgAndDescribeNew":"AAee0taa-0sLUPl-tXoXF","backG":"_1eFSWNqUifiOxe7283zMR9","shopName":"_MEBpEoT1UlWq0x8jALCu","span1":"_23crAXS5L-dIPKv0gzyLcd","span2":"_1APQ67fB6biJSptAQPC8l3","text2":"_27F7a3knKv6FkFUezohOm5","bottomInfo":"_3Kf5PcX1rtU2Vyc4q-L2O2","info":"QcDVpcBb-uH5Seul_DOnD","item":"JF7nO_LWbIp1Zh6dIGjfa","qrcodeImg":"_1nr1SKgtFxGWJOXqKLCo1q"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/DesignerDetailComponent/DesignerDetailComponent.scss
 ** module id = 958
 ** module chunks = 0
 **/